// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__b6yzS","header":"ReportDetails_header__2m7yU","title":"ReportDetails_title__1yu13","left":"ReportDetails_left__4WvhJ"};